import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  roles: [],
};

export const createRole = createAsyncThunk(
  "createRole/role",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("roles", data);
      enqueueSnackbar("Role is added successfully");
      navigate(PATH_DASHBOARD.roles.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchRoles = createAsyncThunk(
  "fetchRoles/role",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get("role");
      return {
        data: response.data.data,
        meta: {
          total: response?.data?.data?.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateRole = createAsyncThunk(
  "updateRole/role",
  async ({ id, data, enqueueSnackbar, setOpenEdit, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.put(`role/${id}`, data);
      navigate(PATH_DASHBOARD.roles.list);
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        id,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteRole = createAsyncThunk(
  "deleteRole/role",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`role/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const roleSlice = createSlice({
  name: "roles",
  initialState,
  extraReducers: (builder) => {
    // TODO: create product
    builder.addCase(createRole.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createRole.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createRole.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch product
    builder.addCase(fetchRoles.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRoles.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.roles = action.payload;
    });

    builder.addCase(fetchRoles.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update product
    builder.addCase(updateRole.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateRole.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Role is updated successfully");
      // state.roles.data = state.roles.data.map((product) =>
      //   product.slug === action.payload.slug ? action.payload.data : product,
      // );
      // action.payload.setOpenEdit(false);
    });

    builder.addCase(updateRole.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete product
    builder.addCase(deleteRole.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteRole.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roles.data = state.roles.data.filter(
        (product) => product.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("Role is deleted successfully");
    });

    builder.addCase(deleteRole.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default roleSlice.reducer;
